import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useTranslation } from "react-i18next"
import Button from "../../Button/Button"
import Modal from "../Modal"
import "./styles.scss"

const WarningModal = ({
  visible,
  onHide,
  footer = "",
  className,
  resizable = false,
  draggable = false,
  position = "center",
  onCancel,
  onConfirm,
  buttonLabel = "",
  title = "",
  message = "",
  ...props
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  return (
    <Modal
      visible={visible}
      footer={footer}
      // eslint-disable-next-line @typescript-eslint/no-empty-function
      onHide={typeof onHide === "function" ? onHide : () => {}}
      draggable={draggable}
      resizable={resizable}
      position={position}
      closeOnEscape={false}
      closable={false}
      size='small'
      className={className}
      {...props}
    >
      <div className='mb-2 d-flex flex-column warning-info-main-content'>
        <div className='mb-2 d-flex justify-content-center'>
          <div className='icon-warning_container'>
            <div className='icon-warning_container inner_container'>
              <FontAwesomeIcon icon={["fal", "warning"]} />
            </div>
          </div>
        </div>
        <div className='mt-2 d-flex flex-column'>
          <h4 className='warning-title'>{title}</h4>
          <p className='mt-3 warning-text'>{message}</p>
          <div className='d-flex warning-btn_container'>
            <p
              className='warning-cancel_btn'
              onClick={onCancel}
            >
              {t("bancos.conciliacion.modal.cancelButton")}
            </p>
            <Button
              label={buttonLabel}
              variant='contained'
              className='!tw-bg-primary'
              onClick={onConfirm}
            />
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default WarningModal
